
import { Api } from './Api';
import { ILoggerService } from './Services/Logging/ILoggerService';
import { LoggerService } from './Services/Logging/LoggerService';

export interface IEvent {
    Subscribe(handler: { (): void }): void;
    Unsubscribe(handler: { (): void }): void;
}

export class Event implements IEvent {
    private _log: ILoggerService = Api.Get<ILoggerService>(LoggerService.ServiceName);

    private handlers: { (): void; }[] = [];

    public Subscribe(handler: { (): void }): void {
        if (!this.handlers.includes(handler))
            this.handlers.push(handler);
    }

    public Unsubscribe(handler: { (): void }): void {
        this.handlers = this.handlers.filter(h => h !== handler);
    }

    public Invoke() {
        this.handlers.slice(0).forEach(h => {
            try {
                h();
            }
            catch (ex: any) {
                this._log.Error(ex);
            }
        });
    }
}